import { PermissionsEnums } from "../dtos/permissions-enums";

export const claimPermissions = [
  PermissionsEnums.CLAIMS_VIEW,
  PermissionsEnums.CLAIMS_ADJUSTER,
  PermissionsEnums.CLAIMS_MANAGER,
  PermissionsEnums.CLAIMS_ADMIN,
];